import { CommonModule }         from '@angular/common';
import { FormsModule }          from '@angular/forms';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TranslateModule }      from '@ngx-translate/core';

import { DirectivesModule }         from '../directives/directives.module';
import { EmailExportComponent }    from '../../export/email-export.component';
import { FileUploadComponent }     from '../../core/directives/file-upload/file-upload.component';
import { FlipperComponent }        from './flipper/flipper.component';
import { IconComponent }          from './icon/icon.component';
import { ImageViewModule }        from './image-viewer/image-viewer.module';
import { ListBoxComponent }       from './list-box/list-box.component';
import { SearchEmailModalComponent } from '../../../app/messages/search-email-modal.component';
import { WizardComponent }        from './wizard/wizard.component';
import { WizardStepComponent }    from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    SearchEmailModalComponent,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    SearchEmailModalComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    CommonModule,
    FormsModule,

    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    SearchEmailModalComponent,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbProgressbarModule,
    TranslateModule,

    //Custom
    DirectivesModule,
    ImageViewModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class ComponentsModule {}
